import React from 'react';
import { Grid } from 'antd';
import { Box, css } from 'theme-ui';
import styled from '@emotion/styled';

type Props = {
  md: number
  preContent?: React.ReactNode
  postContent?: React.ReactNode
}
export const CardBox: React.FC<Props> = ({ md, preContent, postContent, children }) => {
  const breaks = Grid.useBreakpoint();
  const hasMT = false && !preContent;

  return (
    <Box sx={{ flex: [1, 1, 1, md] }} className="card">
      {preContent && (
        <TopContainer className="top">{preContent}</TopContainer>
      )}
      {(breaks.sm || breaks.md) && (
        <Card bg="#fff" mt={hasMT ? [0, 0, 64] : null}>
          {children}
        </Card>
      )}
      {(breaks.xs) && (
        <Box bg="#fff" p={3} mb={4}>
          {children}
        </Box>
      )}
      {postContent && (
        <div>{postContent}</div>
      )}
    </Box>
  );
};

const Card = styled(Box)(css({
  fontSize: 14,
  borderRadius: 8,
  border: '1px solid #f0f0f0',
  p: [null, 16, 24],
  px: [null, 16, 24, 32],
}));

const TopContainer = styled(Box)(css({
  height: '64px',
  px: 3,
}));

export default CardBox;
